import { uniqueValues } from '@gig/magic-common';
import { Mixins, Prop, Component } from 'vue-property-decorator';
import { store } from '../../store/index.js';
import '../../mixins/static-page.mixin.js';
import { PromotionsMixin } from '../../mixins/promotions.mixin.js';
import '../../mixins/landing-page.mixin.js';
import { CompetitionsMixin } from '../../mixins/competitions.mixin.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const ALL_PROMOTIONS_ID = "all";
let PromotionsComponent = class extends Mixins(PromotionsMixin, CompetitionsMixin) {
  constructor() {
    super(...arguments);
    this.visibleCategories = false;
    this.hiddenCategories = [];
    this.activeTab = ALL_PROMOTIONS_ID;
  }
  setAllCategoriesVisible() {
    this.visibleCategories = this.categoriesWithPromotions.map((category) => category.title === "landing" ? "" : category.id);
  }
  setVisibleCategories(category) {
    if (category === ALL_PROMOTIONS_ID) {
      this.setAllCategoriesVisible();
      return;
    }
    this.visibleCategories = [category];
  }
  toggleVisibleCategories(value) {
    if (!this.visibleCategories) {
      const categories = this.promotionsWithCategory.map(({ category }) => {
        return category.id;
      });
      this.visibleCategories = categories;
    }
    if (this.visibleCategories.includes(value)) {
      this.visibleCategories = this.visibleCategories.filter((category) => category !== value);
      return;
    }
    this.visibleCategories.push(value);
  }
  get promotionsWithCategory() {
    if (!this.promotions || !this.categories) {
      return [];
    }
    const promotionsWithCategory = this.categories.reduce((acc, category) => __spreadProps(__spreadValues({}, acc), {
      [category.id]: { category, promotions: [] }
    }), {});
    this.promotions.forEach((promotion) => {
      const { catId } = promotion;
      if (!catId || !promotionsWithCategory[catId]) {
        return;
      }
      promotionsWithCategory[catId].promotions.push(promotion);
    });
    return Object.values(promotionsWithCategory).filter((item) => {
      return item.promotions.length > 0;
    }).map((item) => {
      return __spreadProps(__spreadValues({}, item), {
        category: __spreadProps(__spreadValues({}, item.category), {
          visible: this.visibleCategories ? this.visibleCategories.includes(item.category.id) : true
        })
      });
    });
  }
  get categoriesWithPromotions() {
    const categoriesWithPromotions = uniqueValues(this.promotions.map(({ catId }) => catId));
    return this.categories.filter((category) => categoriesWithPromotions.includes(category.id));
  }
  get collapsibleItems() {
    if (!this.promotions || !this.categories) {
      return [];
    }
    const items = this.categoriesWithPromotions.map((category) => ({
      name: category.title,
      slug: category.id
    }));
    return [
      {
        name: this.$t("promotions.all.button"),
        slug: ALL_PROMOTIONS_ID
      }
    ].concat(items);
  }
  get hiddenCategoryOptions() {
    return this.hiddenCategories.map(({ name, slug }) => ({
      name,
      value: slug
    }));
  }
  setHiddenCategories(hidden) {
    this.hiddenCategories = hidden;
  }
  getTag(promotion) {
    if (!promotion || !promotion.types) {
      return "";
    }
    const tag = promotion.types.find((type) => type !== this.type);
    if (!tag) {
      return "";
    }
    return this.$t(`promotions.tag.${tag}`);
  }
  selectCategory(e) {
    this.activeTab = e.detail[0];
    this.setVisibleCategories(e.detail[0]);
  }
  openAccordion(id) {
    this.activeTab = "";
    this.toggleVisibleCategories(id);
  }
};
__decorateClass([
  Prop({ type: Boolean, default: false })
], PromotionsComponent.prototype, "alignCategoriesLeft", 2);
__decorateClass([
  Prop({ type: Boolean, default: false })
], PromotionsComponent.prototype, "hideCategoriesSelector", 2);
__decorateClass([
  Prop({ type: Boolean, default: false })
], PromotionsComponent.prototype, "topNavigation", 2);
PromotionsComponent = __decorateClass([
  Component({
    name: "promotions",
    store
  })
], PromotionsComponent);

export default PromotionsComponent;
